import type { PayloadAction } from '@reduxjs/toolkit';
import type { AddPaymentRequestBody } from '@/domains/payments/features/paymentModals/modals/AddPayment/types/requests/AddPaymentRequest';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Modals } from '@/features/serviceModal/enums/Modals';
import { SnackType } from '@/features/snacks/enums/SnackType';
import { getPayments } from '@/domains/payments/features/PaymentsSection/store/payments.slice';
import {
  addPayment,
  addPaymentError,
  addPaymentSuccess,
} from '@/domains/payments/features/paymentModals/modals/AddPayment/store/addPayment.slice';
import PaymentFormEvent from '@/domains/payments/features/paymentModals/shared/events';
import EventService from '@/services/EventService/EventService';
import HttpService from '@/services/HttpService/HttpService';
import ModalService from '@/services/ModalService/ModalService';
import SnacksService from '@/services/SnackService/SnackService';

function* addPaymentSaga({ payload }: PayloadAction<AddPaymentRequestBody>) {
  try {
    yield call(HttpService.post, '/payment', payload, {
      baseURL: import.meta.env.VITE_API_URL,
    });

    yield put(addPaymentSuccess({ claimId: payload.claimId }));
    yield put(getPayments({ claimId: payload.claimId }));

    SnacksService.add({
      type: SnackType.Success,
      title: 'Payment has been added successfully',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
    ModalService.close(Modals.AddPayment);
  } catch (error) {
    console.error(error);
    ModalService.close(Modals.AddPayment);
    yield put(addPaymentError());
  } finally {
    EventService.dispatch(new PaymentFormEvent.CreateRequestSuccess({}));
  }
}

export function* addPaymentWatcher() {
  yield takeLatest([addPayment.type], addPaymentSaga);
}
